import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import RouteModel from "../../models/route";

export default class RouteRepository extends BaseRepository {
  static modelClass = RouteModel;
  modelName = "route";
}
